import React from "react";

import { LiveChatWidget } from "@livechat/widget-react";

export const LiveChat = () => {
	return <LiveChatWidget license="12122364" />;
};

export default LiveChat;
